import axios from "axios";
import NetworkUtils from "@/NetworkUtils";
import store from "../../store";
const authorize =  `Bearer ${store.getters.getToken}`;
const config = {
    headers: { Authorization: authorize }
};

export default {

    loadItemNameData : async function() {
        let data = await axios.get(NetworkUtils.HOST + '/item-name', config);
        let itemNames = [];
        let tranformIconGroup = [];
        if (data.data.length > 0) {
            itemNames = data.data[0].list;
            if(data.data[0].tranformIconGroup){
                tranformIconGroup = data.data[0].tranformIconGroup;
            }
        }
        return {itemNames, tranformIconGroup};
    },

    loadWeaponNameData : async function() {
        let data = require('../assets/json/item-weapon-name-ref.json');
        return data;
    },

    loadPotionNameData : async function() {
        let listData = require('../assets/json/item-potion-name-ref.json');
        return listData;
    }
}